// tslint:disable:max-line-length
// tslint:disable:member-ordering

export class Data {

    constructor() {
        this.highlights['jrc_neuro'] = this.highlights['jrc-noncancer'];
        this.highlights['hilda_parkinson'] = this.highlights['jrc-noncancer'];
        this.highlights['nanopigs2'] = this.highlights['nanopigs'];
        this.highlights['nanopigs-3'] = this.highlights['nanopigs'];

        this.projectsAcceptedTags['nanopigs2'] = this.projectsAcceptedTags['nanopigs'];
        this.projectsAcceptedTags['nanopigs-3'] =
            this.projectsAcceptedTags['nanopigs'];

        this.projectsAcceptedTags['pndt_rab2006'] = this.projectsAcceptedTags['pndt'];

        this.projectsAcceptedTags['tmp'] = this.projectsAcceptedTags['pndt'];

        this.projectsAcceptedTags['pndt_exp1'] = this.projectsAcceptedTags['pndt'];
        this.projectsAcceptedTags['pndt_exp2'] = this.projectsAcceptedTags['pndt'];

        this.projectsValues['nanopigs2'] = this.projectsValues['nanopigs'];
        this.projectsValues['nanopigs-3'] = this.projectsValues['nanopigs'];
        this.projectsValues['pndt_rab2006'] = this.projectsValues['pndt'];
        this.projectsValues['pndt_exp1'] = this.projectsValues['pndt'];
        this.projectsValues['pndt_exp2'] = this.projectsValues['pndt'];

    }


    highlights = {
        cardio: [
            'biomarker',
            'disease',
            'model',
            'organoid',
            'stem',
            'cell'
        ],
        bpa: [
            'bisphenol',
            'bpa',
            'kinetic',
            'mode\\s*of\\s*action',
            'mechanism\\s*of\\s*action',
            '​rat',
            'rabbit',
            'mouse',
            'mice',
            'human',
            'expos',
            'vivo',
            'vitro',
        ],
        pndt_rab2006: [
            'rat',
            'rabbit',
            'GI',
            'gastro',
            'intest',
            'diarrhea',
            'weight',
            'food',
            'irritation',
            'bleed',
            'blood',
            'stomach',
            'lesion',
            'offspring',
            'biocide',
            'antibiotic',
            'birth',
            'resorpt',
            'malform',
            'inflammat',
            'oral',
            'feed'

        ],
        'jrc-noncancer': [
            'in\s+vivo',
            'in\s+vitro',
            'in\s+silico',
            'ex\s+vivo',
            '3r',
            'non\s+animal',
            'non\s*-\s*animal',
            'alternative',
            'organoid',
            'respirat',
            'lung',
            'airway',
            'alveol',
            'fibrosis',
            'cystic',
            'copd',
            'chronic\s+obstructive\s+pulmonary',
            'asthma'
        ],
        nanopigs: [
            'nano\\w*',
            'pigment\\w*',
            'colou?r\\w*',
            'tox\\w*',
            'advers\\w*',
            'damag\\w*',
            'poison\\w*',
            'risk\\w*',
            'hazard\\w*',
            'titanium dioxide',
            'zinc oxide',
            'carbon black',
            'amide\\w*',
            'dione\\w*',
            'expos\\w*',
            'size\\w*',
            'particle\\w*',
            'tio2',
            'zno',
            'emis\\w*',
        ],
        glykoalkaloids: [
            'solanin\\w*', 'chaconin\\w*', 'glyco\\w*', 'alkaloid\\w*', 'spartein\\w*', 'lupin\\w*', 'lupanin\\w*', 'aphylline\\w*', 'quinolizidin\\w*', 'hplc', '\bgc\b', '\bms\b', '\bir\b', 'chromato\\w*', 'spectr\\w*', 'occur\\w*', 'animal\\w*', 'vivo', 'vitro', 'human\\w*', 'absorb\\w*', 'distribu\\w*', 'metabol\\w*', 'excret\\w*', 'chain\\w*', 'tox\\w*', 'epidem\\w*', 'poison\\w*', 'adverse\\w*', 'potat\\w*', 'tomat\\w*', 'eggplant\\w*', 'leaves', 'leaf', 'peel\\w*', 'fruit\\w*', 'tuber\\w*', 'cultivar\\w*', 'matur\\w*', 'proces\\w*', 'rat', 'cattle', 'sheep', 'pig', 'rabbit', 'goat', 'poultry', 'chicken', 'fish', 'dog', 'horse', 'mink', 'farm', 'solanum', 'food', 'feed',
        ],
        quinoalkaloids: [
            'solanin\\w*', 'chaconin\\w*', 'glyco\\w*', 'alkaloid\\w*', 'spartein\\w*', 'lupin\\w*', 'lupanin\\w*', 'aphylline\\w*', 'quinolizidin\\w*', 'hplc', '\bgc\b', '\bms\b', '\bir\b', 'chromato\\w*', 'spectr\\w*', 'occur\\w*', 'animal\\w*', 'vivo', 'vitro', 'human\\w*', 'absorb\\w*', 'distribu\\w*', 'metabol\\w*', 'excret\\w*', 'chain\\w*', 'tox\\w*', 'epidem\\w*', 'poison\\w*', 'adverse\\w*', 'potat\\w*', 'tomat\\w*', 'eggplant\\w*', 'leaves', 'leaf', 'peel\\w*', 'fruit\\w*', 'tuber\\w*', 'cultivar\\w*', 'matur\\w*', 'proces\\w*', 'rat', 'cattle', 'sheep', 'pig', 'rabbit', 'goat', 'poultry', 'chicken', 'fish', 'dog', 'horse', 'mink', 'farm', 'solanum', 'food', 'feed',
        ]
    };


    projectsValues = {
        'bpa': {
            acceptAbstract: [
                ['ih', 'Included - human'],
                ['ias', 'Included - animal study'],
                ['imoa', 'Included - MoA study'],
                ['unc', 'Uncertain (see fulltext)']
            ],
            acceptFulltext: [
                ['ih', 'Included - human'],
                ['ias', 'Included - animal study'],
                ['imoa', 'Included - MoA study'],
            ],
            rejectAbstract: [
                ['told', 'Too old'],
                ['sec', 'Secondary study'],
                ['notr', 'Not relevant'],
                ['funot', 'Fulltext not in English'],
                ['invitro', 'In vitro/in silico human/animal study'],
                ['biomon', 'Biomonitoring study'],
                ['expos', 'Exposure route'],
                ['nonmam', 'Non-mammalian'],
                ['mixt', 'Mixture (except arm BPA)'],
                ['nocont', 'No negative control group (animal)'],
                ['invmoa', 'In vitro MoA testing BPA >100 nM'],
            ],
            rejectFulltext: [
                ['told', 'Too old'],
                ['sec', 'Secondary study'],
                ['notr', 'Not relevant'],
                ['funot', 'Fulltext not in English'],
                ['invitro', 'In vitro/in silico human/animal study'],
                ['biomon', 'Biomonitoring study'],
                ['expos', 'Exposure route'],
                ['nonmam', 'Non-mammalian'],
                ['mixt', 'Mixture (except arm BPA)'],
                ['nocont', 'No negative control group (animal)'],
                ['invmoa', 'In vitro MoA testing BPA >100 nM'],
            ]
        },
        'jrc-respiratory': {
            notRatedAbstract: [['notRated', 'Not Rated']
            ],
            acceptAbstract: [
                ['nonanimal', 'Non-animal method'],
                ['respiratory', 'Respiratory disease']],
            rejectAbstract: [
                ['animal', 'Animal method'],
                ['nonrespiratory', 'Not respiratory disease'],
                ['inadequate', 'Inadequate method description'],
                ['unsource', 'Unknown source'],
                ['clinstudy', 'Clinical case study'],
                ['drug', 'Drug formulation study'],
                ['nonmodel', 'Not model system'],
                ['respinf', 'Respiratory infection'],
                ['anicell', 'Animal cells']
            ],
            notRatedFulltext: [['notRated', 'Not Rated']
            ],
            acceptFulltext: [
                ['included', 'Included'],
            ],
            rejectFulltext: [
                ['notprimary', 'not primary literature'],
                ['tooold', 'too old (2006 and older)'],
                ['invivo', 'in vivo'],
                ['notresp', 'not respiratory'],
                ['notvalid', 'method not validated'],
                ['poor', 'method poorly described'],
                ['clinstudy', 'Clinical case study'],
                ['drug', 'Drug formulation study'],
                ['nonmodel', 'Not model system'],
                ['respinf', 'Respiratory infection'],
                ['anicell', 'Animal cells']
            ],
        },
        'cardio': {
            notRatedAbstract: [
                ['notRated', 'Not Rated'],
                ['2ndExpert', 'Assigned to 2nd Expert'],
            ],
            acceptAbstract: [
                ['included', 'Included'],
                ['fulltextDecision', 'Abstract unclear, fulltext needed']],
            rejectAbstract: [
                ['review', 'Review article'],
                ['nonprimary', 'not primary reference of the method'],
                ['invivo', 'in vivo'],
                ['outside', 'Outside the area of interest'],
                ['old', 'Too old (< 2008)'],
                ['unvalidated', 'Method not validated'],
                ['clinstudy', 'Clinical case study'],
                ['seminar', 'Seminar/meeting proceedings'],
                ['nonenglish', 'Abstract not in english'],
            ],
            notRatedFulltext: [['notRated', 'Not Rated']
            ],
            acceptFulltext: [
                ['included', 'Included'],
            ],
            rejectFulltext: [
                ['freview', 'Review article'],
                ['fnonprimary', 'not primary reference of the method'],
                ['finvivo', 'in vivo'],
                ['foutside', 'Outside the area of interest'],
                ['funvalidated', 'Method not validated'],
                ['fclinstudy', 'Clinical case study'],
                ['fseminar', 'Seminar/meeting proceedings'],
                ['fnonenglish', 'Text not in english'],
            ],
        },
        'hilda_alzheimer': {
            notRatedAbstract: [['notRated', 'Not Rated']
            ],
            acceptAbstract: [
                ['accept', 'Accept'],
                ['uncertain',
                    'Uncertain: insufficient  info (get fulltext)'],
                ['secopin', 'Uncertain: advice 2nd expert']
            ],
            rejectAbstract: [
                ['not_primary', 'Not primary literature'],
                ['not_major', 'Not major ND disease, not ND relevant model or endpoint'],
                ['not_relevant', 'Non-human model organisms'],
                ['clinstudy', 'Human clinical, therapeutic or genetic screening studies'],
                ['imaging', 'Imaging methods'],
                ['other', 'Other reason for exclusion'],
            ],
            notRatedFulltext: [['notRated', 'Not Rated']
            ],
            acceptFulltext: [
                ['faccept', 'Accept'],
                ['fsecopin', 'Uncertain: advice 2nd expert']
            ],
            rejectFulltext: [
                ['fnot_primary', 'Not primary literature'],
                ['fnot_major', 'Not major neurodegenerative diseases: AD, PD, ALS, FTD, MS'],
                ['fnot_relevant', 'Not human model organisms'],
                ['fnot_NDD_model', 'Model system and/or biological endpoint not NDD relevant'],
                ['fclinstudy', 'Human clinical, therapeutic or genetic screening studies'],
                ['fimaging', 'Imaging methods'],
                ['finsufficient', 'Insufficient method description'],
                ['fnometh', 'Not original method paper'],
                ['fother', 'Other reason for exclusion'],
            ],
        },
        'hilda_parkinson': {
            notRatedAbstract: [['notRated', 'Not Rated']
            ],
            acceptAbstract: [
                ['accept', 'Accept'],
                ['uncertain',
                    'Uncertain: insufficient  info (get fulltext)'],
                ['secopin', 'Uncertain: advice 2nd expert']
            ],
            rejectAbstract: [
                ['not_primary', 'Not primary literature'],
                ['not_major', 'Not major neurodegenerative diseases: AD, PD, ALS, FTD, MS'],
                ['not_relevant', 'Non-human model organisms'],
                ['not_NDD_model', 'Model system and/or biological endpoint not NDD relevant'],
                ['clinstudy', 'Human clinical, therapeutic or genetic screening studies'],
                ['imaging', 'Imaging methods'],
                // ['insufficient', 'Insufficient method description'],
                // ['not_original', 'Not original method paper'],
                ['other', 'Other reason for exclusion'],
            ],
            notRatedFulltext: [
                ['notRated', 'Not Rated']
            ],
            acceptFulltext: [
                ['faccept', 'Accept'],
                ['fsecopin', 'Uncertain: advice 2nd expert']
            ],
            rejectFulltext: [
                ['fnot_primary', 'Not primary literature'],
                ['fnot_major', 'Not major neurodegenerative diseases: AD, PD, ALS, FTD, MS'],
                ['fnot_relevant', 'Not human model organisms'],
                ['fnot_NDD_model', 'Model system and/or biological endpoint not NDD relevant'],
                ['fclinstudy', 'Human clinical, therapeutic or genetic screening studies'],
                ['fimaging', 'Imaging methods'],
                ['finsufficient', 'Insufficient method description'],
                ['fnometh', 'Not original method paper'],
                ['fother', 'Other reason for exclusion'],
            ],
        },
        'jrc-noncancer': {
            notRatedAbstract: [['notRated', 'Not Rated']
            ],
            acceptAbstract: [
                ['included', 'Included'],
                ['uncertain', 'Uncertain (see fulltext)']],
            rejectAbstract: [
                ['notprimary', 'not primary literature'],
                ['tooold', 'too old (2006 and older)'],
                ['invivo', 'in vivo'],
                ['notresp', 'not respiratory'],
                ['notvalid', 'method not validated'],
                ['poor', 'method poorly described'],
                ['clinstudy', 'Clinical case study'],
                ['drug', 'Drug formulation study'],
                ['nonmodel', 'Not model system'],
                ['respinf', 'Respiratory infection'],
                ['anicell', 'Animal cells']
            ],
            notRatedFulltext: [['notRated', 'Not Rated']
            ],
            acceptFulltext: [
                ['included', 'Included'],
            ],
            rejectFulltext: [
                ['notprimary', 'not primary literature'],
                ['tooold', 'too old (2006 and older)'],
                ['invivo', 'in vivo'],
                ['notresp', 'not respiratory'],
                ['notvalid', 'method not validated'],
                ['poor', 'method poorly described'],
                ['clinstudy', 'Clinical case study'],
                ['drug', 'Drug formulation study'],
                ['nonmodel', 'Not model system'],
                ['respinf', 'Respiratory infection'],
                ['anicell', 'Animal cells']
            ],
        },
        pndt: {
            notRatedAbstract: [
                ['notRated', 'Not Rated']
            ],
            acceptAbstract: [
                ['rat', 'Rat'],
                ['rabbit', 'Rabbit'],
                ['uncertain', 'Uncertain (see fulltext)']],
            rejectAbstract: [
                ['otherspec', 'Other species (not rats or rabbits)'],
                ['irrelevant', 'Not related to gastro-intestinal effects']],
            notRatedFulltext: [
                ['notRated', 'Not Rated']
            ],
            acceptFulltext: [
                ['rat', 'Rat'],
                ['rabbit', 'Rabbit']],
            rejectFulltext: [
                ['otherspec', 'Other species (not rats or rabbits)'],
                ['irrelevant', 'Not related to gastro-intestinal effects']
            ]
        },
        pndt_rats: {
            notRatedAbstract: [
                ['notRated', 'Not Rated']
            ],
            acceptAbstract: [
                ['rat', 'Rat'],
                ['other', 'Other species'],
                ['uncertain', 'Uncertain (see fulltext)']],
            rejectAbstract: [
                ['bacterial', 'Bacterial'],
                ['irrelevant', 'Not relevant']],
            notRatedFulltext: [
                ['notRated', 'Not Rated']
            ],
            acceptFulltext: [
                ['rat', 'Rat'],
                ['other', 'Other species']
            ],
            rejectFulltext: [
                ['bacterial', 'Bacterial'],
                ['irrelevant', 'Not relevant']
            ]
        },
        nanopigs: {
            notRatedAbstract: [
                ['notRated', 'Not Rated']
            ],
            acceptAbstract: [
                ['included', 'Included'],
                ['uncertain', 'Uncertain (see fulltext)']],
            rejectAbstract: [
                ['notnano', 'Not nano (standard form only)'],
                ['irrelevant', 'Other']
            ]
        },
        glykoalkaloids: {
            notRatedAbstract: [['notRated', 'Not Rated'],
            ['assignNew', 'Assign new reviewer']
            ],
            acceptAbstract: [
                ['asolanine', 'a-solanine'],
                ['achaconine', 'a-chaconine'],
                ['bchaconine', 'b-chaconine'],
                ['seefulltext', 'See fulltext'],
                ['other', 'other'],
            ],
            rejectAbstract: [
                //  ['duplicate', 'Duplicate'],
                ['notclear',
                    'Not clear if the publication deals with compounds of interest'],
                ['positive',
                    'Positive effects'],
                ['studytype',
                    'Study type (patent, dissertation and/or thesis, conference proceedings paper)'],
                ['outside',
                    'Outside the areas of interest (Area 1-10)'],
                ['old',
                    'Too old (published before 1950)'],
                ['notenglish',
                    'Abstract not in English']
                // ['irrelevant', 'Irrelevant'],
                //  ['mishit', 'Mishit']
            ]
        },
        quinoalkaloids: {
            notRatedAbstract: [['notRated', 'Not Rated'],
            ['assignNew', 'Assign new reviewer']
            ],
            acceptAbstract: [
                ['sparteine', 'sparteine'],
                ['lupinine', 'lupinine'],
                ['epilupinine', 'epi-lupinine'],
                ['lupanine', 'lupanine'],
                ['aphylline', 'aphylline'],
                ['epiaphylline', 'epi-aphylline'],
                ['nutalline', 'nutalline'],
                ['seefulltext', 'See fulltext'],
                ['other', 'other'],
            ],
            rejectAbstract: [
                //  ['duplicate', 'Duplicate'],
                ['notclear',
                    'Not clear if the publication deals with compounds of interest'],
                ['positive',
                    'Positive effects'],
                ['studytype',
                    'Study type (patent, dissertation and/or thesis, conference proceedings paper)'],
                ['outside',
                    'Outside the areas of interest (Area 1-10)'],
                ['old',
                    'Too old (published before 1950)'],
                ['notenglish',
                    'Abstract not in English']
                // ['irrelevant', 'Irrelevant'],
                //  ['mishit', 'Mishit']
            ]
        }
    };

    projectsAcceptedTags = {
        'hilda_alzheimer': [
            ['1tp|1: Type of paper', [
                '1arew|1a: Review (focused to NDD alternative methods)',
                '1bnew|1b: New method (original paper on alternative method development/validation)',
                '1cmethod|1c: Method comparison or test strategy (alternative method used in comparison, or for validation to other non-alternative methods)',
                '1dappl|1d: Application (existing, alternative method for different purposes used: e.g.                     drug development &amp;testing, neuroprotection, toxicants, food, plant extracts,..…)',
                '1eresults|1e: Results comparison (findings obtained with different animal/non-animal methods)'
            ]],
            ['2ndd|2: NDD disease', [
                '2aad|2a: Alzheimer disease (AD)',
                '2bpd|2b: Parkinson disease (PD)',
                '2cals|2c: Amyotrophic lateral sclerosis (ALS)',
                '2dftd|2d: Frontotemporal dementia (FTD)',
                '2ems|2e: Multiple sclerosis (MS)',
                '2fneur|2f. Neurodegenerative diseases (NDD) (if abstract on ND in general with endpoints relevant for any of the 5 diseases, and/or no specific of 5 ND disease mentioned)'
            ]],
            ['3|3: Model systems', [
                '3atissue|3a: Human/patient ex-vivo tissue or body fluids (brain biopsy, blood, CSF, CSF, post-mortem, saliva, urine))',
                '3bstem|3b: Human/patient primary or stem cells',
                '3ccel|3c: Human-derived cell lines',
                '3dcocult|3d: 3D model and/or co-culture',
                '3eorganoid|3e: Organoid model',
                '3fbiochem|3f: Biochemical/cell-free assay',
                '3glab|3g: Lab/brain on chip or microfluidic system',
                '3hcomp|3h: Computational/in silico',
                '3ioth|3i. Other (specify in notes)'
            ]],
            ['4|4: Cell types', [
                '4aneur|4a: Neuronal cells',
                '4bglial|4b: Glial cells (astrocytes; microglia, schwann cells, oligodendrocytes)',
                '4cipsc|4c:  iPSCs (induced pluripotent stem cells, different sources)',
                '4dnsc|4d: NSCs (neural stem cells  or progenitor cells)',
                '4eembry|4e: Human embryonic cells',
                '4fsh|4f: SH-SY5Y cells',
                '4gother|4g: Other (specify in notes)',
                '4hna: 4h. NA (= not applicable, method does not make use of cells)',
            ]],
            ['5|5: Biological endpoint/read out', [
                '5agene|5a: Gene expression (incl. Transcriptomics, real time RT-PCR,..)',
                '5bprot|5b: Protein expression (incl. Proteomics, Elisa,..)',
                '5clipid|5c: Lipidomics',
                '5dmetab|5d: Metabolomics',
                '5eneuro|5e: Neuroinflammation',
                '5foxid|5f: Oxidative stress',
                '5gapop|5g: Apoptosis',
                '5hmito|5h: Mitochondrial function',
                '5ilyso|5i: Lysosomal function',
                '5jaxon|5j: Axon function/structure/retraction',
                '5kneuro|5k: Neurotransmission (incl. Acetylcholine, other transmitters)',
                '5lexi|5l: Excitotoxicity',
                '5mauto|5m: Autophagy',
                '5nglio|5n: Gliosis',
                '5otau|5o: Tau (NFT, phosphorylated tau...)',
                '5pamylo|5p: Amyloid  (Plaques, Abeta, Ab peptides)',
                '5qsynu|5q: Synuclein (Lewy bodies)',
                '5rprotagg|5r: Protein aggregation  (NFT, plaques, Lewy bodies, proteasomal stress,..)',
                '5sdopam|5s: Dopaminerg',
                '5tbl|5t: Blood brain barrier ',
                '5umor|5u: Morphology/ultrastructural changes ',
                '5vsyn|5v: Synapse function',
                '5wcel|5w: Cell death or degeneration',
                '5xmicro|5x: Microglial dysfunction',
                '5yalig|5y: Oligodendrocyte dysfunction',
                '5zastr|5z: Astrocyte dysfunction',
                '5aaneur|5aa: Neuron dysfunction ',
                '5abschw|5ab: Schwann cell dysfunction',
                '5acsubs|5ac: Substantia nigra',
                '5adapo|5ad: ApoE ',
                '5aetdp|5ae: TDP-43 protein',
                '5afmut|5af: Mutations (SOD1, FUS,..)',
                '5agphas|5ag: Phase separation or transition',
                '5ahaut|5ah: Autoimmunity',
                '5aimye|5ai: Myelin, or demyelination',
                '5ajnitr|5aj: Nitrosative stress',
                '5akother|5ak: Other (specify in notes)',

            ]]
        ],
        'hilda_parkinson': [
            ['1tp|1: Type of paper', [
                '1arew|1a: Review (focused to NDD alternative methods)',
                '1bnew|1b: New method (original paper on alternative method development/validation)',
                '1cmethod|1c: Method comparison or test strategy (alternative method used in comparison, or for validation to other non-alternative methods)',
                '1dappl|1d: Application (existing, alternative method for different purposes used: e.g. drug development & testing, neuroprotection, toxicants, food, plant extracts,..…)',
                '1ecomp|1e: Results comparison (findings obtained with different animal/non-animal methods)'
            ]],
            ['2ndd|2: NDD disease', [
                '2aad|2a: Alzheimer disease (AD)',
                '2bpd|2b: Parkinson disease (PD)',
                '2cals|2c: Amyotrophic lateral sclerosis (ALS)',
                '2dftd|2d: Frontotemporal dementia (FTD)',
                '2ems|2e: Multiple sclerosis (MS)',
            ]],
            ['3|3: Model systems', [
                '3atissue|3a: Human/patient ex-vivo tissue or body fluids (brain biopsy, CSF, , post-mortem)',
                '3bstem|3b: Human/patient primary or stem cells',
                '3ccel|3c: Human-derived cell lines',
                '3dcocult|3d: 2D or 3D co-culture',
                '3eorganoid|3e: Organoid model',
                '3fbiochem|3f: Biochemical/cell-free assay',
                '3glab|3g: Lab/brain on chip or microfluidic system',
                '3hcomp|3h: Computational/in silico',
                '3ioth|3i: Other (specify in notes)',
            ]],
            ['4|4: Cell types', [
                '4aneur|4a: Neuronal cells',
                '4bglial|4b: Glial cells (astrocytes; microglia, schwann cells, oligodendrocytes)',
                '4cipsc|4c: iPSCs (induced pluripotent stem cells)',
                '4dnsc|4d: NSCs (neural stem cells)',
                '4eoth|4e: Other (specify in notes)',
            ]],
            ['5|5: Biological endpoint/read out', [
                '5agene|5a: Gene expression (incl. Transcriptomics, real time RT-PCR,..)',
                '5bprot|5b: Protein expression (incl. Proteomics, Elisa,..)',
                '5clipid|5c: Lipidomics',
                '5dmetab|5d: Metabolomics',
                '5eneuro|5e: Neuroinflammation',
                '5foxid|5f: Oxidative stress',
                '5gapop|5g: Apoptosis',
                '5hmito|5h: Mitochondrial function',
                '5ilyso|5i: Lysosomal function',
                '5jaxon|5j: Axon function/structure/retraction',
                '5kneuro|5k: Neurotransmission (incl. Acetylcholine, other transmitters)',
                '5lexi|5l: Excitotoxicity',
                '5mauto|5m: Autophagy',
                '5nglio|5n: Gliosis',
                '5otau|5o: Tau  (NFT, phosphorylated tau...)',
                '5pamylo|5p: Amyloid (Plaques, Abeta, Ab peptides)',
                '5qsynu|5q: Synuclein (Lewy bodies)',
                '5rprotagg|5r: Protein aggregation',
                '5sdopam|5s: Dopaminerg',
                '5tblodbr|5t: Blood brain barrier ',
                '5umorph|5u: Morphology/ultrastructural changes ',
                '5vsynaps|5v: Synapse function',
                '5wcdeath|5w: Cell death or degeneration',
                '5xmicroglia|5x: Microglial dysfunction',
                '5yoligoden|5y: Oligodendrocyte dysfunction',
                '5zastorcyt|5z: Astrocyte dysfunction',
                '5aanurodys|5aa: Neuron dysfunction ',
                '5abschwan|5ab: Schwann cell dysfunction',
                '5acsubstnigr|5ac: Substantia nigra',
                '5adapoe|5ad: ApoE ',
                '5aetdp|5ae: TDP-43 protein',
                '5afmutati|5af: Mutations (SOD1, FUS,..)',
                '5agphassep|5ag Phase separation or transition',
                '5ahautoim|5ah: Autoimmunity',
                '5aimyelin|5ai: Myelin, or demyelination',
                '5ajnitrosa|5aj: Nitrosative stress',
                '5akother|5ak: Other (specify in notes)',
            ]]
        ],
        'bpa': [
            ['1hs|1: Human study', [
                '1a|1a: Cohort',
                '1b|1b: Case - control',
                '1c|1c: Toxicokinetics',
                '1d|1d: Cross sectional',
            ]],
            ['2as|2: Animal study', [
                '2a|2a: In vivo',
                '2b|2b: Toxicokinetic',
            ]],
            ['3moas|3: MoA study', [
                '3a|3a: Oral',
                '3b|3b: Dermal',
                '3c|3c: Inhalation',
                '3d|3d: sc',
                '3e|3e: ip',
                '3f|3f: iv',
                '3g|3g: in vivo genotox',
            ]]
        ],
        'jrc-respiratory': [
            ['1dt|1: Disease types', [
                '1aasthma|1a: Asthma',
                '1bcopd|1b: COPD',
                '1clung|1c: Lung Cancer',
                '1dpulm|1d: Pulmonary Fibrosis',
                '1epneu|1e: Pneumonia',
                '1ftuber|1f: Tuberculosis',
                '1gcystic|1g: Cystic fibrosis',
                '1hmeso|1h: Mesothelioma',
                '1ibronch|1i: Bronchiolitis obliterans',
                '1j|1j: emphysema',
                '1k|1k: cigarettes',
                '1l|1l: electronic cigarettes',
                '1m|1m: hyperreactivity',
            ]],
            ['2ms|2: Model systems', [
                '2a|2a: in vivo',
                '2b|2b: in vitro',
                '2c|2c: in silico',
                '2d|2d: organoid',
                '2e|2e: chip-based',
                '2fcocul|2f: co-culture'
            ]],
            ['3ct|3: Cell types', [
                '3a|3a: endothelial',
                '3b|3b: pulmonary artery',
                '3c|3c: epithelial',
                '3d|3d: macrophage',
                '3e|3e: neutrophil',
                '3f|3f: eosinophil',
                '3g|3g: mast cell',
                '3h|3h: immune cell',
                '3i|3i: fibroblast',
                '3j|3j: patient specimen',
                '3k|3k: explant',
                '3l|3l: lavage',
                '3m|3m: smooth muscle'
            ]],
            ['4ro|4: Read outs', [
                '4a|4a: cytokine release',
                '4b|4b: inflammatory mediators',
                '4c|4c: mRNA expression',
                '4d|4d: gene expression',
                '4e|4e: protein',
                '4f|4f: chemotaxis',
                '4g|4g: repair',
                '4h|4h: phagocytosis',
                '4i|4i: apoptosis',
                '4j|4j: viability',
                '4k|4k: infection',
                '4l|4l: imaging',
                '4m|4m: immunohistochemistry',
                '4n|4n: metabolism',
                '4o|4o: mucin',
            ]],
        ],
        'cardio': [
            ['1dt|1: General Disease Modelling Resource', []],
            ['2ms|2: In vitro Method', [
                '2a|2a: Human-specific (sub)cell-based models',
                '2b|2b: Tissue-based models including two- or three-dimensional cultures/organotypic models',
                '2c|2c: Stem-cell technologies, such as human-induced pluripotent stem cells (iPSC)',
                '2d|2d: Lab-on-a-chip devices with microfluidic systems',
                '2e|2e: Organoid',
                '2fcocul|2f: Other ex-vivo approach'
            ]],
            ['3ct|3: In silico Methods', [
                '3a|3a: Computational modeling',
                '3b|3b: Mathematical modeling',
            ]],
            ['4ro|4: Omics Methods', [
                '4a|4a: DNA Next Generation Sequencing',
                '4b|4b: Transcriptomics',
                '4c|4c: Proteomics',
                '4d|4d: Metabolomics',
            ]],
            ['5xx|5: Ex-vivo and Tissue Engineering Methods', []],
            ['6yy|6: Others', []],
        ],
        'jrc-noncancer': [
            ['1effect|1: Effect', [
                '1aasthma|1a: Asthma',
                '1bcopd|1b: COPD',
                '1ccystic|1c: Cystic fibrosis',
                '1dfibro|1d: fibrosis (other than cystic) ',
                '1ecancer|1e: cancer',
                '1fother|1f: other',
                '1g|1g: emphysema',
                '1h|1h: cigarettes',
                '1i|1i: electronic cigarettes',
                '1j|1j: hyperreactivity',
            ]],
            ['2ms|2: Model systems', [
                '2a|2a: in vitro',
                '2b|2b: ex vivo',
                '2c|2c: in silico',
                '2d|2d: organoid',
                '2e|2e: chip-based',
                '2fother|2f: other',
                '2gcocul|2g: co-culture'
            ]],
            ['3ct|3: Cell types', [
                '3a|3a: endothelial',
                '3b|3b: pulmonary artery',
                '3c|3c: epithelial',
                '3d|3d: macrophage',
                '3e|3e: neutrophil',
                '3f|3f: eosinophil',
                '3g|3g: mast cell',
                '3h|3h: immune cell',
                '3i|3i: fibroblast',
                '3j|3j: patient specimen',
                '3k|3k: explant',
                '3l|3l: lavage',
                '3m|3m: smooth muscle'
            ]],
            ['4ro|4: Readout', [
                '4a|4a: cytokine release',
                '4b|4b: inflammatory mediators',
                '4c|4c: mRNA expression',
                '4d|4d: gene expression',
                '4e|4e: protein',
                '4f|4f: chemotaxis',
                '4g|4g: repair',
                '4h|4h: phagocytosis',
                '4i|4i: apoptosis',
                '4j|4j: viability',
                '4k|4k: infection',
                '4l|4l: imaging',
                '4m|4m: immunohistochemistry',
                '4n|4n: metabolism',
                '4o|4o: mucin',
            ]],
        ],
        'pndt': [
            ['1rat|01: Rat', []],
            ['2rabbit|02: Rabbit', []],
            ['3bwr|03: Body-weight reduction', []],
            ['4rfi|04: Reduced food intake', []],
            ['5si|05: Stomach irritation', []],
            ['6gibleed|06: GI bleeding', []],
            ['7giles|07: GI lesions', []],
            ['8diarrhea|08: Diarrhea', []],
            ['9offspring|09: Offspring effects', [
                '9a|09a: malformations',
                '9b|09b: resorption',
                '9c|09c: pre-mature birth',
                '9d|09d: decreased pup weight',
                '9e|09e: decreased pup number',
                '9f|09f: other']],
            ['10other|10: Other effects', []],
            ['11subugr|11: Substance use / group', [
                '11a|11a: biocide',
                '11b|11b: antibiotic',
                '11c|11c: general chemical',
                '11d|11d: other',
            ]],
        ],
        'pndt_rats': [
            ['1rat|01: Rat', []],
            ['2rabbit|02: Rabbit', []],
            ['3bwr|03: Body-weight reduction', []],
            ['4rfi|04: Reduced food intake', []],
            ['5gi|05: GI irritation', []],
            ['6gibleed|06: GI bleeding', []],
            ['7giles|07: GI lesions', []],
            ['8diarrhea|08: Diarrhea', []],
            ['9offspring|09: Offspring effects', [
                '9a|09a: malformations',
                '9b|09b: resorption',
                '9c|09c: pre-mature birth',
                '9d|09d: decreased pup weight',
                '9e|09e: decreased pup number',
                '9f|09f: other']],
            ['10other|10: Other effects', []],
            ['11subugr|11: Substance use / group', [
                '11a|11a: biocide',
                '11b|11b: antibiotic',
                '11c|11c: NSAIDs',
                '11d|11d: general chemical',
                '11e|11e: other',
            ]],
        ],
        nanopigs: [
            ['1s|1: Substances', [
                '1aunsp|1a: Unspecified (nanopigments in general)',
                '1btidio|1b: Titanium dioxide',
                '1czno|1c: Zinc oxide',
                '1dcb|1d: Carbon black',
                '1ebas|1e: Barium sulphate',
                '1fcah|1f: Calcium hydrogenorthophosphorate',
                '1gfeo|1g: Ferric oxide',
                '1hcaca|1h: Calcium carbonate',
                '1icarb|1i: Carboxamides',
                '1joxo|1j: Oxobutyramides',
                '1knap|1k: Naphthols',
                '1ldio|1k: Diones',
                '1mother|1m: Other (specify in a note)'
            ]],
            ['2prod|2: Products', [
                '2aprod|2a: Paints, inks, etc.',
                '2bfood|2b: Food',
                '2cother|2c: Other'
            ]],
            ['3sub|3: Substance characterisation data', []],
            ['4exp|4: Exposure data', [
                '4ameasur|4a: Measured',
                '4bmodel|4b: Modelled'
            ]],
            ['5tox|5: Toxicological data', [
                '5ainvivo|5a: In vivo',
                '5binvitro|5b: In vitro',
                '5cinsilico|5c: In silico'
            ]],
            ['6epid|6: Epidemiological data', []],
            ['7risk|7: Risk assessment info', []],
            ['8lifecycle|8: Life cycle', [
                '8aindustrial|8a: Industrial',
                '8bprofessional|8b: Professional',
                '8cconsumer|8c: Consumer'
            ]],
            ['9riskmng|9: Risk management', []],
        ],
        glykoalkaloids: [
            ['1ach|1: analytics/chemistry', [
                '1asubst|1a: substance identification',
                '1banalytic|1b: analytical detection',
                '1cform|1c: formation']],
            ['2toxicokin|2: toxicokinetics', [
                '2aexperimental|2a: experimental animals',
                '2bfarm|2b: farm/companion animals',
                '2chumans|2c: humans',
                '2dvitro|2d: in vitro',
                '2ebiomark|2e: biomarkers',
                '2fabs|2f: absorption',
                '2gdist|2g: distribution',
                '2hmet|2h: metabolism',
                '2iexcret|2i: excretion',
                '2htransfer|2h: transfer (food chain)'
            ]],
            ['3mode|3: mode of action', [
                '3avitro|3a: in vitro',
                '3bvivo|3b: in vivo']],
            ['4vivotox|4: in vivo toxicity', [
                '4aacute|4a: acute',
                '4bsubacute|4b: subacute',
                '4csubchronic|4c: subchronic',
                '4dchronic|4d: chronic',
                '4egenotox|4e: genotoxicity',
                '4fcarci|4f: carcinogenicity',
                '4gspecific|4g: specific organ toxicity',
                '4hneuro|4h: neurotoxicity',
                '4iimmuno|4i: immunotoxicity',
                '4jdevelop|4j: developmental',
                '4kterato|4k: teratogenicity',
                '4lother|4l: other']],
            ['5invittox|5: in vitro toxicity', [
                '5aacute|5a: acute',
                '5bsubacute|5b: subacute',
                '5csubchronic|5c: subchronic',
                '5dchronic|5d: chronic',
                '5egenotox|5e: genotoxicity',
                '5fcarci|5f: carcinogenicity',
                '5gspecific|5g: specific organ toxicity',
                '5hneuro|5h: neurotoxicity',
                '5iimmuno|5i: immunotoxicity',
                '5jdevelop|5j: developmental',
                '5kterato|5k: teratogenicity',
                '5lother|5l: other']],
            ['6human|6: human observations data', [
                '6aepido|6a: epidemiological study',
                '6bcase|6b: case report',
                '6cintervent|6c: intervention study',
                '6dpoison|6d: poisoning',
                '6eother|6e: other']],
            ['7animal|7: animal adverse effects', [
                '7acattle|7a: cattle',
                '7bsheep|7e: sheep',
                '7cgoat|7c: goat',
                '7drumin|7d: other ruminants',
                '7epigs|7e: pigs',
                '7fpoultry|7f: poultry',
                '7grabbits|7g: rabbits',
                '7hfish|7h: fish',
                '7icats|7i: cats',
                '7jdogs|7j: dogs',
                '7khorse|7k: horses',
                '7lfarmed|7l: farmed mink',
                '7mother|7m: other']],
            ['8food|8: food occurence', [
                '8acont|8a: content(value) in title/abstract',
                '8bpotato|8b: potato',
                '8ctomato|8c: tomato',
                '8degg|8d: eggplant',
                '8elupin|8e: Lupinus ssp.',
                '8fbapt|8f: Baptisia ssp.',
                '8gtherm|8g: Thermopsis ssp.',
                '8hgenist|8h: Genista ssp.',
                '8icytis|8i: Cytisus ssp.',
                '8jothspec|8j: Other species',
                '8kleaves|8k: Leaves',
                '8lfruit|8l: Fruit',
                '8mtubers|8m: Tubers',
                '8npeels|8n: Peels',
                '8owhole|8o: Whole plant',
                '8pothpart|8p: Other plant part',
            ]],
            ['9feed|9: feed occurence', [
                '9acont|9a: content(value) in title/abstract',
                '9bpotato|9b: potato',
                '9ctomato|9c: tomato',
                '9degg|9d: eggplant',
                '9elupin|9e: Lupinus ssp.',
                '9fbapt|9f: Baptisia ssp.',
                '9gtherm|9g: Thermopsis ssp.',
                '9hgenist|9h: Genista ssp.',
                '9icytis|9i: Cytisus ssp.',
                '9jothspec|9j: Other species',
                '9kleaves|9k: Leaves',
                '9lfruit|9l: Fruit',
                '9mtubers|9m: Tubers',
                '9npeels|9n: Peels',
                '9owhole|9o: Whole plant',
                '9pothpart|9p: Other plant part',
            ]],
            ['10influence|10: influencing factors', [
                '10acultivar|10a: influence of cultivars',
                '10bmaturity|10b: influence of maturity',
                '10cenvironment|10c: influence of environment',
                '10dstorage|10d: influence of storage',
                '10eprocess|10e: influence of processing',
                '10fprocess|10f: other influencing factor']]
        ],
        quinoalkaloids: [
            ['1ach|1: analytics/chemistry', [
                '1asubst|1a: substance identification',
                '1banalytic|1b: analytical detection',
                '1cform|1c: formation']],
            ['2toxicokin|2: toxicokinetics', [
                '2aexperimental|2a: experimental animals',
                '2bfarm|2b: farm/companion animals',
                '2chumans|2c: humans',
                '2dvitro|2d: in vitro',
                '2ebiomark|2e: biomarkers',
                '2fabs|2f: absorption',
                '2gdist|2g: distribution',
                '2hmet|2h: metabolism',
                '2iexcret|2i: excretion',
                '2htransfer|2h: transfer (food chain)'
            ]],
            ['3mode|3: mode of action', [
                '3avitro|3a: in vitro',
                '3bvivo|3b: in vivo']],
            ['4vivotox|4: in vivo toxicity', [
                '4aacute|4a: acute',
                '4bsubacute|4b: subacute',
                '4csubchronic|4c: subchronic',
                '4dchronic|4d: chronic',
                '4egenotox|4e: genotoxicity',
                '4fcarci|4f: carcinogenicity',
                '4gspecific|4g: specific organ toxicity',
                '4hneuro|4h: neurotoxicity',
                '4iimmuno|4i: immunotoxicity',
                '4jdevelop|4j: developmental',
                '4kterato|4k: teratogenicity',
                '4lother|4l: other']],
            ['5invittox|5: in vitro toxicity', [
                '5aacute|5a: acute',
                '5bsubacute|5b: subacute',
                '5csubchronic|5c: subchronic',
                '5dchronic|5d: chronic',
                '5egenotox|5e: genotoxicity',
                '5fcarci|5f: carcinogenicity',
                '5gspecific|5g: specific organ toxicity',
                '5hneuro|5h: neurotoxicity',
                '5iimmuno|5i: immunotoxicity',
                '5jdevelop|5j: developmental',
                '5kterato|5k: teratogenicity',
                '5lother|5l: other']],
            ['6human|6: human observations data', [
                '6aepido|6a: epidemiological study',
                '6bcase|6b: case report',
                '6cintervent|6c: intervention study',
                '6dpoison|6d: poisoning',
                '6eother|6e: other']],
            ['7animal|7: animal adverse effects', [
                '7acattle|7a: cattle',
                '7bsheep|7e: sheep',
                '7cgoat|7c: goat',
                '7drumin|7d: other ruminants',
                '7epigs|7e: pigs',
                '7fpoultry|7f: poultry',
                '7grabbits|7g: rabbits',
                '7hfish|7h: fish',
                '7icats|7i: cats',
                '7jdogs|7j: dogs',
                '7khorse|7k: horses',
                '7lfarmed|7l: farmed mink',
                '7mother|7m: other']],
            ['8food|8: food occurence', [
                '8acont|8a: content(value) in title/abstract',
                '8bpotato|8b: potato',
                '8ctomato|8c: tomato',
                '8degg|8d: eggplant',
                '8elupin|8e: Lupinus ssp.',
                '8fbapt|8f: Baptisia ssp.',
                '8gtherm|8g: Thermopsis ssp.',
                '8hgenist|8h: Genista ssp.',
                '8icytis|8i: Cytisus ssp.',
                '8jothspec|8j: Other species',
                '8kleaves|8k: Leaves',
                '8lfruit|8l: Fruit',
                '8mtubers|8m: Tubers',
                '8npeels|8n: Peels',
                '8owhole|8o: Whole plant',
                '8pothpart|8p: Other plant part',
            ]],
            ['9feed|9: feed occurence', [
                '9acont|9a: content(value) in title/abstract',
                '9bpotato|9b: potato',
                '9ctomato|9c: tomato',
                '9degg|9d: eggplant',
                '9elupin|9e: Lupinus ssp.',
                '9fbapt|9f: Baptisia ssp.',
                '9gtherm|9g: Thermopsis ssp.',
                '9hgenist|9h: Genista ssp.',
                '9icytis|9i: Cytisus ssp.',
                '9jothspec|9j: Other species',
                '9kleaves|9k: Leaves',
                '9lfruit|9l: Fruit',
                '9mtubers|9m: Tubers',
                '9npeels|9n: Peels',
                '9owhole|9o: Whole plant',
                '9pothpart|9p: Other plant part',
            ]],
            ['10influence|10: influencing factors', [
                '10acultivar|10a: influence of cultivars',
                '10bmaturity|10b: influence of maturity',
                '10cenvironment|10c: influence of environment',
                '10dstorage|10d: influence of storage',
                '10eprocess|10e: influence of processing',
                '10fprocess|10f: other influencing factor']]
        ]
    };
}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/data.ts